import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import { mergeObjectUtil } from 'packages/src'

const primary = STYLES_COLOR.BLUE
const paragraph = STYLES_COLOR.BLACK_LIGHT
const subheading = STYLES_COLOR.BLACK_LIGHT
const accent = '#e63946'
const accent2 = '#a8dadc'
// const border = '#D6DCEC'
const border = '#e6e6e6'

const red = '#e63946'
const protein = red
const green = '#43D051'
const fat = green
const orange = '#FE9006'
const carbs = orange

function verticalScale (val) {
  return val
}

const defaultSpace = 8
// const buttonHeight = 45
const buttonHeight = 42
const defaultFontSize = 18

// const breakpoints = {
//   xs: 0, // extra-small: 0px
//   sm: 600, // small: 600px
//   md: 900, // medium: 900px
//   lg: 1200, // large: 1200px
//   xl: 1536 // extra-large: 1536px
// }

const spaces = {
  smaller: verticalScale(defaultSpace / 2),
  small: verticalScale(defaultSpace),
  default: verticalScale(defaultSpace),
  big: verticalScale(defaultSpace * 2)
}

const sizes = {
  icons: {
    SMALL: 16,
    NORMAL: 24,
    BIG: 32
  }
}

const borderRadius = {
  medium: '5px',
  button: '0.625em',
  big: '50%'
  // button: buttonHeight / 2
}

const zIndex = {
  header: 3
}

const THEME_VARIABLES = {
  em: verticalScale(defaultFontSize),
  // breakpoints,
  fontSizes: {
    smallest: '0.67em',
    smaller: '0.77em',
    small: '0.88em',
    body: '1em',
    bodyBig: '1.2em',
    title: '1.5em',
    titleBig: '2em'
  },
  heights: {
    input: `${verticalScale(40)}px`,
    button: `${verticalScale(buttonHeight)}px`
  },
  spaces,
  sizes,
  borderRadius,
  zIndex,
  maxWidth: {
    desktop: '1440px',
    desktopCompact: '1200px'
  }
}

const grey = '#BABABA'
const white = '#ffffff'
const black = '#151D21'
const text = black
const colors = {
  primary,
  input: '#e0e1e6',
  background: '#fff',
  grey,
  disabled: grey,
  // backgroundContent: '#eff0f4',
  backgroundContent: '#fafafa',
  black,
  text,
  white,
  paragraph,
  subheading,
  border,
  accent,
  red,
  protein,
  carbs,
  orange,
  green,
  fat,
  accent2

}
const DEFAULT_THEME = {
  light: {
    colors
  }
  // dark: {
  //   colors: {
  //     primary,
  //     input: '#202022',
  //     backgroundContent: '#191919',
  //     white,
  //     paragraph,
  //     subheading,
  //     accent,
  //     accent2
  //   }
  // }
}

const THEME = {
  light: mergeObjectUtil(
    DEFAULT_THEME.light,
    THEME_VARIABLES
  )
  // light: mergeObjectUtil(PaperDefaultTheme, NavigationDefaultTheme, THEME_VARIABLES),
  // dark: mergeObjectUtil(PaperDarkTheme, NavigationDarkTheme, THEME_VARIABLES),
}

export function useTheme () {
  return THEME.light
}

export function getEmValueFromStringThemeUtil (emStr) {
  const emValStr = emStr.slice(
    0,
    emStr.indexOf('em')
  )
  return parseFloat(emValStr)
}
